import React, { useEffect, useState } from "react";
import './ProductShowcase.css'
import { ReactComponent as Logo } from '../../assets/logo/logo-name.svg';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const ProductShowcase = () => {

    const showcaseProducts = useSelector((state) => state.product.displayproducts) || [];



    useEffect(() => {

        const handleOutsideClick = (e) => {

            if (
                window.innerWidth <= 768 &&
                !e.target.closest(".showcase-cabinet")
            ) {
                setSelectedProduct(null);
            }
        };

        document.addEventListener(
            "click",
            handleOutsideClick
        );

        return () => {
            document.removeEventListener(
                "click",
                handleOutsideClick
            );
        };

    }, []);

    const [selectedProduct, setSelectedProduct] = useState(null);


        const navigate = useNavigate();
          const viewDetails = (name, id) => {
      navigate(`/${encodeURIComponent(name.replaceAll(" ", "-"))}/${id}`);
    };

    return (
        <div className="slider5">

            <div className="luxury-header">
                <span>CURATED TO PERFECTION</span>

                <h2>
                    Timeless Brilliance,
                    Exclusively Yours
                </h2>

                <p>
                    Discover our handpicked collection of rare diamonds and
                    fine jewellery, each piece crafted to celebrate life's
                    most precious moments.
                </p>
            </div>

            <div className="showcase-row">

                {showcaseProducts.map((item, index) => (

                    <div
                        key={item._id}
                        className={`showcase-cabinet ${selectedProduct === item._id ? "active" : ""
                            } ${index === 2 ? "featured-cabinet" : ""}`}
                        onClick={(e) => {

                            if (window.innerWidth <= 768) {

                                e.stopPropagation();

                                setSelectedProduct(
                                    selectedProduct === item._id
                                        ? null
                                        : item._id
                                );
                            }
                        }}
                    >

                        <div className="spotlight"></div>

                        <div className="glass-box">

                            <img
                                src={item.displayImage}
                                alt={item.name}
                                className="showcase-image"
                            />

                        </div>

                        <div className="cabinet-logo">
                            <Logo className="logo-image" />
                        </div>

                        <div className="cabinet-legs">

                            <span className="leg leg1"></span>
                            <span className="leg leg2"></span>
                            <span className="leg leg3"></span>
                            <span className="leg leg4"></span>

                        </div>
                        <div
                            className={`showcase-details ${selectedProduct === item.id
                                    ? "mobile-show"
                                    : ""
                                }`}
                        >

                            <h3>{item.name}</h3>

                            {/* <p>{item.category}</p> */}

                            <span>{item.defaultPrice}</span>

                            <button onClick={() => viewDetails(item.name,item._id)} className="showcase-btn">
                                View Details
                            </button>

                        </div>

                    </div>

                ))}

            </div>

        </div>
    );
}

export default ProductShowcase;